import process from 'process';
import path from 'path';
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }
  return target;
}

/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

var invariant = function (condition, format, a, b, c, d, e, f) {
  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }
    error.framesToPop = 1; // we don't care about invariant's own frame

    throw error;
  }
};
var invariant_1 = invariant;
var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}
var urlTemplate = createCommonjsModule(function (module, exports) {
  (function (root, factory) {
    {
      module.exports = factory();
    }
  })(commonjsGlobal, function () {
    /**
     * @constructor
     */
    function UrlTemplate() {}
    /**
     * @private
     * @param {string} str
     * @return {string}
     */

    UrlTemplate.prototype.encodeReserved = function (str) {
      return str.split(/(%[0-9A-Fa-f]{2})/g).map(function (part) {
        if (!/%[0-9A-Fa-f]/.test(part)) {
          part = encodeURI(part).replace(/%5B/g, '[').replace(/%5D/g, ']');
        }
        return part;
      }).join('');
    };
    /**
     * @private
     * @param {string} str
     * @return {string}
     */

    UrlTemplate.prototype.encodeUnreserved = function (str) {
      return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
      });
    };
    /**
     * @private
     * @param {string} operator
     * @param {string} value
     * @param {string} key
     * @return {string}
     */

    UrlTemplate.prototype.encodeValue = function (operator, value, key) {
      value = operator === '+' || operator === '#' ? this.encodeReserved(value) : this.encodeUnreserved(value);
      if (key) {
        return this.encodeUnreserved(key) + '=' + value;
      } else {
        return value;
      }
    };
    /**
     * @private
     * @param {*} value
     * @return {boolean}
     */

    UrlTemplate.prototype.isDefined = function (value) {
      return value !== undefined && value !== null;
    };
    /**
     * @private
     * @param {string}
     * @return {boolean}
     */

    UrlTemplate.prototype.isKeyOperator = function (operator) {
      return operator === ';' || operator === '&' || operator === '?';
    };
    /**
     * @private
     * @param {Object} context
     * @param {string} operator
     * @param {string} key
     * @param {string} modifier
     */

    UrlTemplate.prototype.getValues = function (context, operator, key, modifier) {
      var value = context[key],
        result = [];
      if (this.isDefined(value) && value !== '') {
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
          value = value.toString();
          if (modifier && modifier !== '*') {
            value = value.substring(0, parseInt(modifier, 10));
          }
          result.push(this.encodeValue(operator, value, this.isKeyOperator(operator) ? key : null));
        } else {
          if (modifier === '*') {
            if (Array.isArray(value)) {
              value.filter(this.isDefined).forEach(function (value) {
                result.push(this.encodeValue(operator, value, this.isKeyOperator(operator) ? key : null));
              }, this);
            } else {
              Object.keys(value).forEach(function (k) {
                if (this.isDefined(value[k])) {
                  result.push(this.encodeValue(operator, value[k], k));
                }
              }, this);
            }
          } else {
            var tmp = [];
            if (Array.isArray(value)) {
              value.filter(this.isDefined).forEach(function (value) {
                tmp.push(this.encodeValue(operator, value));
              }, this);
            } else {
              Object.keys(value).forEach(function (k) {
                if (this.isDefined(value[k])) {
                  tmp.push(this.encodeUnreserved(k));
                  tmp.push(this.encodeValue(operator, value[k].toString()));
                }
              }, this);
            }
            if (this.isKeyOperator(operator)) {
              result.push(this.encodeUnreserved(key) + '=' + tmp.join(','));
            } else if (tmp.length !== 0) {
              result.push(tmp.join(','));
            }
          }
        }
      } else {
        if (operator === ';') {
          if (this.isDefined(value)) {
            result.push(this.encodeUnreserved(key));
          }
        } else if (value === '' && (operator === '&' || operator === '?')) {
          result.push(this.encodeUnreserved(key) + '=');
        } else if (value === '') {
          result.push('');
        }
      }
      return result;
    };
    /**
     * @param {string} template
     * @return {function(Object):string}
     */

    UrlTemplate.prototype.parse = function (template) {
      var that = this;
      var operators = ['+', '#', '.', '/', ';', '?', '&'];
      return {
        expand: function (context) {
          return template.replace(/\{([^\{\}]+)\}|([^\{\}]+)/g, function (_, expression, literal) {
            if (expression) {
              var operator = null,
                values = [];
              if (operators.indexOf(expression.charAt(0)) !== -1) {
                operator = expression.charAt(0);
                expression = expression.substr(1);
              }
              expression.split(/,/g).forEach(function (variable) {
                var tmp = /([^:\*]*)(?::(\d+)|(\*))?/.exec(variable);
                values.push.apply(values, that.getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
              });
              if (operator && operator !== '+') {
                var separator = ',';
                if (operator === '?') {
                  separator = '&';
                } else if (operator !== '#') {
                  separator = operator;
                }
                return (values.length !== 0 ? operator : '') + values.join(separator);
              } else {
                return values.join(',');
              }
            } else {
              return that.encodeReserved(literal);
            }
          });
        }
      };
    };
    return new UrlTemplate();
  });
});

/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

var UID = Math.floor(Math.random() * 0x10000000000).toString(16);
var PLACE_HOLDER_REGEXP = new RegExp('"@__(F|R|D)-' + UID + '-(\\d+)__@"', 'g');
var IS_NATIVE_CODE_REGEXP = /\{\s*\[native code\]\s*\}/g;
var IS_PURE_FUNCTION = /function.*?\(/;
var UNSAFE_CHARS_REGEXP = /[<>\/\u2028\u2029]/g;
var RESERVED_SYMBOLS = ['*', 'async']; // Mapping of unsafe HTML and invalid JavaScript line terminator chars to their
// Unicode char counterparts which are safe to use in JavaScript strings.

var ESCAPED_CHARS = {
  '<': '\\u003C',
  '>': '\\u003E',
  '/': '\\u002F',
  '\u2028': '\\u2028',
  '\u2029': '\\u2029'
};
function escapeUnsafeChars(unsafeChar) {
  return ESCAPED_CHARS[unsafeChar];
}
var serializeJavascript = function serialize(obj, options) {
  options || (options = {}); // Backwards-compatibility for `space` as the second argument.

  if (typeof options === 'number' || typeof options === 'string') {
    options = {
      space: options
    };
  }
  var functions = [];
  var regexps = [];
  var dates = []; // Returns placeholders for functions and regexps (identified by index)
  // which are later replaced by their string representation.

  function replacer(key, value) {
    if (!value) {
      return value;
    } // If the value is an object w/ a toJSON method, toJSON is called before
    // the replacer runs, so we use this[key] to get the non-toJSONed value.

    var origValue = this[key];
    var type = typeof origValue;
    if (type === 'object') {
      if (origValue instanceof RegExp) {
        return '@__R-' + UID + '-' + (regexps.push(origValue) - 1) + '__@';
      }
      if (origValue instanceof Date) {
        return '@__D-' + UID + '-' + (dates.push(origValue) - 1) + '__@';
      }
    }
    if (type === 'function') {
      return '@__F-' + UID + '-' + (functions.push(origValue) - 1) + '__@';
    }
    return value;
  }
  function serializeFunc(fn) {
    var serializedFn = fn.toString();
    if (IS_NATIVE_CODE_REGEXP.test(serializedFn)) {
      throw new TypeError('Serializing native function: ' + fn.name);
    } // pure functions, example: {key: function() {}}

    if (IS_PURE_FUNCTION.test(serializedFn)) {
      return serializedFn;
    }
    var argsStartsAt = serializedFn.indexOf('(');
    var def = serializedFn.substr(0, argsStartsAt).trim().split(' ').filter(function (val) {
      return val.length > 0;
    });
    var nonReservedSymbols = def.filter(function (val) {
      return RESERVED_SYMBOLS.indexOf(val) === -1;
    }); // enhanced literal objects, example: {key() {}}

    if (nonReservedSymbols.length > 0) {
      return (def.indexOf('async') > -1 ? 'async ' : '') + 'function' + (def.join('').indexOf('*') > -1 ? '*' : '') + serializedFn.substr(argsStartsAt);
    } // arrow functions

    return serializedFn;
  }
  var str; // Creates a JSON string representation of the value.
  // NOTE: Node 0.12 goes into slow mode with extra JSON.stringify() args.

  if (options.isJSON && !options.space) {
    str = JSON.stringify(obj);
  } else {
    str = JSON.stringify(obj, options.isJSON ? null : replacer, options.space);
  } // Protects against `JSON.stringify()` returning `undefined`, by serializing
  // to the literal string: "undefined".

  if (typeof str !== 'string') {
    return String(str);
  } // Replace unsafe HTML and invalid JavaScript line terminator chars with
  // their safe Unicode char counterpart. This _must_ happen before the
  // regexps and functions are serialized and added back to the string.

  if (options.unsafe !== true) {
    str = str.replace(UNSAFE_CHARS_REGEXP, escapeUnsafeChars);
  }
  if (functions.length === 0 && regexps.length === 0 && dates.length === 0) {
    return str;
  } // Replaces all occurrences of function, regexp and date placeholders in the
  // JSON string with their string representations. If the original value can
  // not be found, then `undefined` is used.

  return str.replace(PLACE_HOLDER_REGEXP, function (match, type, valueIndex) {
    if (type === 'D') {
      return "new Date(\"" + dates[valueIndex].toISOString() + "\")";
    }
    if (type === 'R') {
      return regexps[valueIndex].toString();
    }
    var fn = functions[valueIndex];
    return serializeFunc(fn);
  });
};
function merge() {
  var defaultObj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var overrideObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return Object.keys(_objectSpread({}, defaultObj, overrideObj)).reduce(function (acc, key) {
    var defaultValue = defaultObj[key];
    var overrideValue = overrideObj[key];
    var nextValue = key in overrideObj ? overrideValue : defaultValue;
    if (_typeof(nextValue) === "object" && !Array.isArray(nextValue) && defaultValue && overrideValue) {
      acc[key] = merge(defaultValue, overrideValue);
    } else {
      acc[key] = nextValue;
    }
    return acc;
  }, {});
}
var hasStr = function hasStr(obj) {
  return typeof obj === "string" && obj.length;
};
/**
 * By default this is the value is the current working directory /config.
 * You can change this by defining the environment variable
 * "NODE_CONFIG_DIR" similar to node-config:
 * https://github.com/lorenwest/node-config/wiki/Environment-Variables
 *
 * @return {String} returns the absolute path to config directory
 */

var getPath = function getPath() {
  return hasStr(process.env.NODE_CONFIG_DIR) ? process.env.NODE_CONFIG_DIR : path.join(process.cwd(), "config");
};
var initConfig = function initConfig() {
  // If the window object is available and config has been attached to it, use that.
  if (typeof window !== "undefined" && _typeof(window.__CONFIG__) === "object") {
    return window.__CONFIG__;
  } // If we are running in node, use config files

  if (typeof process !== "undefined" && process.versions !== null && process.versions.node !== null) {
    var configPath = getPath();
    var configEnv = process.env.CONFIG_ENV;
    try {
      // Grab the base, default config.
      var defaultConfig = require("".concat(configPath, "/default.js")); // If this is a non-default config env, grab the secondary config overrides.

      if (hasStr(configEnv)) {
        var envConfigPath = "".concat(configPath, "/").concat(configEnv, ".js");
        try {
          var envConfigJS = require(envConfigPath);
          var envConfig = envConfigJS;
          return merge(defaultConfig, envConfig);
        } catch (e) {
          console.error("Failed to merge \"".concat(envConfigPath, "\""));
        }
      }
      return defaultConfig;
    } catch (e) {
      console.error(e, "Error initializing config-api object");
    }
  }
  return new Map();
};
var config = initConfig();
function get(obj, stringKeys) {
  var keys = stringKeys.split(".");
  return keys.reduce(function (acc, key) {
    return acc ? acc[key] : undefined;
  }, obj);
}
var DEFAULT_INT_RADIX = 10;
function getRawValue(key) {
  invariant_1(typeof key === "string", "Config key must be a string");
  var value = get(config, key);
  invariant_1(value !== undefined, "No value available for the provided for key:".concat(key));
  return value;
}
function getObject(key) {
  var value = getRawValue(key);
  invariant_1(_typeof(value) === "object", "Config value must be type object for ".concat(key));
  return value;
}
function getString(key) {
  var value = getRawValue(key);
  invariant_1(typeof value === "string", "Config value must be type string for ".concat(key));
  return value;
}
/**
 * Look up a URI template (RFC 6570) contained in the application
 * configuration, interpolate it using the supplied parameters (in
 * 'param') and return the rendered URL as a string.
 *
 * @param {String} key The '.'-delimited path to config file entry containing URI template
 * @param {Object} params The map of values to substitute into the URI template
 * @returns {String} A URL string
 */

function getURL(key, params) {
  var value = getString(key);
  invariant_1(_typeof(params) === "object", "A URL parameter map must be an object: params:".concat(params, " key:").concat(key));
  return urlTemplate.parse(value).expand(params);
}
function getInteger(key) {
  var radix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_INT_RADIX;
  var value = Number.parseInt(" ".concat(getRawValue(key)), radix);
  invariant_1(!Number.isNaN(value), "Config value must be type Number for ".concat(key));
  return value;
}
function getFloat(key) {
  var value = Number.parseFloat(" ".concat(getRawValue(key)));
  invariant_1(!Number.isNaN(value), "Config value must be type Number for ".concat(key));
  return value;
}
var getBoolean = function getBoolean(key) {
  var value = getRawValue(key);
  invariant_1(typeof value === "boolean", "Config value must be type Boolean for ".concat(key));
  return value;
};
var hasKey = function hasKey(key) {
  return Boolean(get(config, key));
};
var toString = function toString() {
  return serializeJavascript(config);
};
export { get, getBoolean, getFloat, getInteger, getObject, getRawValue, getString, getURL, hasKey, toString };